import { render } from "./DetailsPassings.vue?vue&type=template&id=600c659b&scoped=true"
import script from "./DetailsPassings.vue?vue&type=script&lang=js"
export * from "./DetailsPassings.vue?vue&type=script&lang=js"

import "./DetailsPassings.vue?vue&type=style&index=0&id=600c659b&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600c659b"]])

export default __exports__